import favAndroid144 from '../../../assets/images/android-icon-144x144.avif';
import favAndroid192 from '../../../assets/images/android-icon-192x192.avif';
import favAndroid36 from '../../../assets/images/android-icon-36x36.avif';
import favAndroid48 from '../../../assets/images/android-icon-48x48.avif';
import favAndroid72 from '../../../assets/images/android-icon-72x72.avif';
import favAndroid96 from '../../../assets/images/android-icon-96x96.avif';
import favApple114 from '../../../assets/images/apple-icon-114x114.avif';
import favApple120 from '../../../assets/images/apple-icon-120x120.avif';
import favApple144 from '../../../assets/images/apple-icon-144x144.avif';
import favApple152 from '../../../assets/images/apple-icon-152x152.avif';
import favApple180 from '../../../assets/images/apple-icon-180x180.avif';
import favApple57 from '../../../assets/images/apple-icon-57x57.avif';
import favApple60 from '../../../assets/images/apple-icon-60x60.avif';
import favApple72 from '../../../assets/images/apple-icon-72x72.avif';
import favApple76 from '../../../assets/images/apple-icon-76x76.avif';
import fav16 from '../../../assets/images/favicon-16x16.avif';
import fav32 from '../../../assets/images/favicon-32x32.avif';
import fav96 from '../../../assets/images/favicon-96x96.avif';

export const seoIconsLinks = [
  {
    href: favApple57,
    rel: 'apple-touch-icon',
    sizes: '57x57',
    type: 'image/avif',
  },
  {
    href: favApple60,
    rel: 'apple-touch-icon',
    sizes: '60x60',
    type: 'image/avif',
  },
  {
    href: favApple72,
    rel: 'apple-touch-icon',
    sizes: '72x72',
    type: 'image/avif',
  },
  {
    href: favApple76,
    rel: 'apple-touch-icon',
    sizes: '76x76',
    type: 'image/avif',
  },
  {
    href: favApple114,
    rel: 'apple-touch-icon',
    sizes: '114x114',
    type: 'image/avif',
  },
  {
    href: favApple120,
    rel: 'apple-touch-icon',
    sizes: '120x120',
    type: 'image/avif',
  },
  {
    href: favApple144,
    rel: 'apple-touch-icon',
    sizes: '144x144',
    type: 'image/avif',
  },
  {
    href: favApple152,
    rel: 'apple-touch-icon',
    sizes: '152x152',
    type: 'image/avif',
  },
  {
    href: favApple180,
    rel: 'apple-touch-icon',
    sizes: '180x180',
    type: 'image/avif',
  },
  { href: favAndroid36, rel: 'icon', sizes: '36x36', type: 'image/avif' },
  { href: favAndroid48, rel: 'icon', sizes: '48x48', type: 'image/avif' },
  { href: favAndroid72, rel: 'icon', sizes: '72x72', type: 'image/avif' },
  { href: favAndroid96, rel: 'icon', sizes: '96x96', type: 'image/avif' },
  {
    href: favAndroid144,
    rel: 'icon',
    sizes: '144x144',
    type: 'image/avif',
  },
  {
    href: favAndroid192,
    rel: 'icon',
    sizes: '192x192',
    type: 'image/avif',
  },
  { href: fav16, rel: 'icon', sizes: '16x16', type: 'image/avif' },
  { href: fav32, rel: 'icon', sizes: '32x32', type: 'image/avif' },
  { href: fav96, rel: 'icon', sizes: '96x96', type: 'image/avif' },
];
